import React, { useState, useEffect } from 'react';
import { satisfaction as api } from '../services/api';
import { estPassage, VehiculeEnvoi } from './SatisfactionCommun';

const CANAL_ENVOI = { email: '✉️ E-mail', sms: '📱 SMS', 'sms+email': '📱 SMS + ✉️ E-mail' };

function fmtDate(d) {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch { return '—'; }
}

// Date sans heure : découpée telle quelle, sans `new Date` (lecture UTC).
function fmtJour(d) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
}

// Longueur comptée comme Mobbiz : texte désaccentué (cf. satisfaction-messages.js).
const longueurSms = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').length;

/**
 * Une ligne d'OBSERVATION : ce que le planificateur aurait envoyé à ce client.
 * Les messages affichés sont ceux qu'il a figés au moment du calcul, jamais un
 * rendu refait ici : l'écran ne doit pas pouvoir montrer autre chose que ce
 * qui serait parti. Le lien du questionnaire est désactivé à l'écran : le jeton
 * d'une ligne simulée n'ouvre rien côté public (« lien inconnu »).
 */
export default function SatisfactionObservationModal({ envoiId, onClose }) {
  const [envoi, setEnvoi] = useState(null);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    api.getEnvoi(envoiId)
      .then(({ data }) => setEnvoi(data.envoi))
      .catch((e) => setErreur(e.response?.data?.error || 'Chargement impossible'));
  }, [envoiId]);

  const sansMessage = envoi && !envoi.message_sms && !envoi.message_email_objet;

  return (
    <div className="modal-overlay">
      <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>👁️ Message qui serait parti</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {erreur && <div className="status-error sat-bandeau">{erreur}</div>}
          {!envoi && !erreur && <div className="sat-vide">Chargement…</div>}
          {envoi && (
            <>
              <div className="status-warning sat-bandeau">
                Observation : rien n'est parti, ce client n'a pas été contacté.
              </div>
              <div className="sat-obs-entete">
                <div><span>Client</span>{[envoi.client_civilite, envoi.client_prenom, envoi.client_nom].filter(Boolean).join(' ') || '—'}</div>
                <div><span>Point de vente</span>{envoi.site_nom || envoi.site_code || '—'}</div>
                <div><span>Formulaire</span>{envoi.formulaire_nom}</div>
                {envoi.marque && <div><span>Marque</span>{envoi.marque}</div>}
                {(envoi.immat || envoi.chassis) && (
                  <div><span>{envoi.immat ? 'Plaque' : 'VIN'}</span><VehiculeEnvoi immat={envoi.immat} chassis={envoi.chassis} vinComplet /></div>
                )}
                {envoi.date_vente && (
                  <div>
                    <span>{estPassage(envoi.formulaire_source) ? 'Passage atelier le' : 'Vendu le'}</span>
                    {fmtJour(envoi.date_vente)}
                  </div>
                )}
                <div><span>Calculé le</span>{fmtDate(envoi.envoye_le)}</div>
                <div><span>Canal</span>{CANAL_ENVOI[envoi.canal_envoi] || envoi.canal_envoi}</div>
              </div>
              {envoi.note_canal && <div className="status-info sat-bandeau">ℹ️ {envoi.note_canal}</div>}

              {sansMessage && (
                <div className="sat-vide">
                  Message non conservé : cette ligne a été calculée avant le 05/10/2026, date à partir de
                  laquelle le planificateur fige le texte exact de chaque message. Le modèle du formulaire
                  reste lisible dans ⚙️ Formulaires ▸ Messages ▸ 👁️ Aperçu.
                </div>
              )}
              {envoi.message_sms && (
                <div className="sat-obs-message">
                  <h3>📱 SMS <small>({longueurSms(envoi.message_sms)}/160)</small></h3>
                  <div className="sat-message">{envoi.message_sms}</div>
                </div>
              )}
              {envoi.message_email_objet && (
                <div className="sat-obs-message">
                  <h3>✉️ E-mail</h3>
                  <div className="sat-obs-objet"><b>Objet :</b> {envoi.message_email_objet}</div>
                  {/* HTML produit par satisfaction-messages.corpsHtml : variables échappées, seul le lien est une ancre. */}
                  <div className="sat-message sat-obs-corps" dangerouslySetInnerHTML={{ __html: envoi.message_email_html || '' }} />
                </div>
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
}
